import React, { useEffect, useState } from 'react'
import { ColumnsTable } from 'safe'
import Table from '../../../components/Display/Table'
import Button from '../../../components/General/Button'
import axios from 'axios'
import useSnackBars from '../../../hooks/SnackbarConsumerHook'

const server = process.env.REACT_APP_SERVER_URL

const AddReceivableProduct: React.FC<IAddReceivable> = ({
  purchase,
  onClose,
  done
}) => {
  const { addAlert } = useSnackBars()

  const [items, setItems] = useState<any[]>([])

  const onChange = (id, e) => {
    if (!Number.isNaN(+e.target.value)) {
      let newArray = items.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            receivedCopy: e.target.value,
            newReceived: +e.target.value - +item?.received || 0,
          }
        }
        return item
      })
      setItems(newArray)
    }
  }

  useEffect(() => {
    console.log('items..', items)
  }, [items])

  const columns: ColumnsTable[] = [
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Cantidad',
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: 'Recibido',
      dataIndex: 'received',
      key: 'received',
      render: (id: number, record: any) => {
        return (
          <input
          style={{width: 80}}
            onChange={(e) => onChange(record?.id, e)}
            value={record?.receivedCopy}
            className="cursor-text transition w-3/6 dark:bg-gray-900 dark:border-gray-600 dark:text-white h-inputDefault"
            type="text"
          />
        )
      },
    },
  ]

  useEffect(() => {
    setItems(
      purchase?.items.map((v) => ({
        ...v,
        receivedCopy: v.received,
        newReceived: 0,
      }))
    )
  }, [purchase?.items])

  const onSave = async (): Promise<void> => {
    console.log('items...', items)
    console.log("")

    let checkIfGreater = items.some(
      (item) => +item?.receivedCopy > +item?.amount
    )

    if (checkIfGreater) {
      addAlert({
        message: 'Los productos recibidos no pueden ser mayor a la cantidad',
        status: 'error',
      })
      return
    }

    let checkAll = items.every((item) => item?.newReceived === 0)

    if (checkAll) {
      addAlert({
        message: 'Debe de realizar al menos alguna modificación',
        status: 'warning',
      })
      return
    }

    addAlert({
      message: 'Modificando productos recibidos',
      status: 'loading',
    })

    let body = {
      id: purchase?.id,
      items: items.map((v) => ({ id: v?.id, received: v?.newReceived })),
    }
    try {
      await axios.post(`${server}/purchase/receive`, body)
      addAlert({
        message: 'Productos recibidos modificados con éxito',
        status: 'success',
      })
      done()
    } catch (err) {
      addAlert({
        message: 'Error al modificar productos recibidos',
        status: 'error',
      })
    }
  }

  return (
    <div>
      <h2 className="col-span-12 mb-2 text-primary-900 font-bold mb-3" style={{color: '#006AEA'}}>
      Agregar Productos Recibidos
      </h2>

      <div className="mt-5">
        <Table columns={columns} data={items} showPagination={false} />
      </div>

      <div className="flex mt-4">
        {onClose && (
          <Button
            type="outline"
            classes="w-1/2 mr-4"
            onClick={() => onClose()}
            htmlType="button"
          >
            Cancelar
          </Button>
        )}
        <Button type="primary" classes="w-1/2 mr-4" onClick={() => onSave()}>
          Guardar cambios
        </Button>
      </div>
    </div>
  )
}

interface IAddReceivable {
  purchase: any
  onClose: () => void
  done: () => void
}

export default AddReceivableProduct
